<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>渠道管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateSourceChannelDialog()">
          新增渠道
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="sourceChannels"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditSourceChannelDialog(item)"
          >mdi-pencil</v-btn
        >
        <v-btn small @click="showDeleteSourceChannelConfirm(item)"
          >mdi-delete</v-btn
        >
      </template>
    </v-data-table>

    <create-source-channel-popup
      ref="createSourceChannelPopup"
    ></create-source-channel-popup>
    <edit-source-channel-popup
      ref="editSourceChannelPopup"
      :item="selectedSourceChannels"
      @update-fff="update__"
    ></edit-source-channel-popup>
    <delete-source-channel-confirmation
      ref="deleteSourceChannelConfirmation"
      :item="selectedSourceChannels"
    ></delete-source-channel-confirmation>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      headers: [{ text: "操作", value: "actions", sortable: false }],
      sourceChannels: [],
      selectedSourceChannels: {},
    };
  },
  methods: {
    showInterviewExpDetail(item) {
      // this.$refs.xx.dialog = true;
      console.log(item);
    },
    showCreateInterviewExpDialog() {
      // this.$refs.xx.dialog = true;
    },
    showEdit__Dialog(item) {
      // this.$refs.xx.dialog = true;
      console.log(item);
    },
    showDelete__Confirm() {
      // this.$refs.xx.dialog = true;
    },
    add__(item) {
      this.xx.push({ ...item });
    },
    update__(item) {
      console.log(item);
    },
    delete__(item) {
      console.log(item);
    },
  },
};
</script>
